import React from "react";
import { object } from "prop-types";

import Organism1 from "./Organism1";
import NewsWithImage from "../../molecules/NewsWithImage";
import ComponentContainer from "../../layouts/component-container";

import "./fourStories.m.css";

const FourStories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [], "associated-metadata": { theme = "default" } = {} } = collection;
  const stories = items.filter(({ type }) => type === "story").map(({ story }) => story);

  if (!stories.length) return null;
  const [firstStory, ...otherStory] = stories;

  return (
    <div styleName="wrapper" className={theme}>
      <ComponentContainer isDesktopBanner={true} isBanner={true} collection={collection}>
        <div styleName="stories">
          <div styleName="first-story">
            <NewsWithImage
              story={firstStory}
              cssStyleName="semiBigSize"
              aspectRatio={[4, 3]}
              imageType="image4x3"
              showExcerpt={true}
              widths={[400, 375, 600]}
            />
          </div>

          <Organism1 stories={otherStory} />
        </div>
      </ComponentContainer>
    </div>
  );
};

FourStories.propTypes = {
  collection: object,
};

FourStories.storyLimit = 5;

export default FourStories;
